import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

interface PageLoaderProps {
  /** Message optionnel sous le spinner */
  message?: string;
}

/**
 * Chargement pleine page (spinner centré).
 * À utiliser pour le chargement initial d’une page ou de données critiques.
 */
const PageLoader: React.FC<PageLoaderProps> = ({ message }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
      py: 4,
    }}
  >
    <CircularProgress />
    {message && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {message}
      </Typography>
    )}
  </Box>
);

export default PageLoader;
